import closeDropdown from "./closeDropdown";

const toggleDropdown = (
  dropdownButton: HTMLButtonElement,
  dropdownMenu: HTMLDivElement
) => {
  const dropdownIsOpen =
    dropdownButton.getAttribute("aria-expanded") === "true";

  if (dropdownIsOpen) {
    closeDropdown(dropdownButton, dropdownMenu);
    return;
  }

  dropdownButton.setAttribute("aria-expanded", "true");
  dropdownMenu.classList.remove("hidden");
};

export default toggleDropdown;
